import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsDeploymentFrequencyClassicBoardRoute: InvariantJiraRoute = {
	name: 'software-reports-deployment-frequency-classic-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
	exact: true,
};
